const DeleteDependent = ({
  ondelete,
  setDeleteDependent,
  translationMap
}) => {
  return (
    <>
      <div
        className="modal fade Custom_Modal_Box show"
        id="deletedependentd"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block" }}>
        
        <div
          className="modal-dialog CoveragePlan_Dialog3"
          role="document">
          
          <div className="modal-content">
            <div className="modal-header">
              <div className="Title_Inner_Box">
                <h6 className="MainTitleOne">
                  {translationMap?.deleteDependent}
                </h6>
              </div>
            </div>
            <div className="modal-body">
              <div className="Manage_Dependent_Modal_Box2">
                <h6 className="Gray_Title">
                  {translationMap?.areYouSureToDeleteDependent}
                </h6>
                <p className="para_txt">
                  {translationMap?.deleteDependentText}
                </p>
              </div>
            </div>
            <div
              className="modal-footer Renewal_Modal_Footer">
              
              <button
                type="button"
                className="btn bluetrans_btn_link"
                data-dismiss="modal"
                onClick={() => {
                  //setCurrentPage("/home");
                  setDeleteDependent(false);
                }}>
                
                {translationMap?.cancel}
              </button>
              <button
                type="button"
                className="btn blue_btn_link"
                onClick={ondelete}>
                
                {" "}
                {translationMap?.proceed}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>);

};

export default DeleteDependent;